<!-- 为你推荐 -->
<template>
<div>
    <swiper :options="swiperOptions">
        <swiper-slide v-for="item in list" :key="item.id">
            <div class="ig"><a :href="item.url" target="_blank"><img :src="item.image|webpFormat(750)" alt=""></a></div>
            <div class="title"><a :href="item.url" target="_blank" >{{item.title}}</a></div>
            <div class="tag">
                <span v-for="(tag,index) in item.tags" :key="index">{{tag}}</span>
            </div>
            <div class="phone">{{item.phone}}</div>
          
        </swiper-slide>
        
        <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
    
</div>
</template>
<script>
export default {
    name:'Recommend',
    data(){
        return {
             // 轮播图配置
            swiperOptions: {
                spaceBetween: 30,
                autoplay: {
                    delay: 3000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false,
                },
                slidesPerView: 2,

                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
            },
            outbreakLoading:true,
            list:[
                {
                    title:'开学季手机计划/家庭网络 TtopBoutique',
                    tags:['上网电视','家庭网络','手机','手机计划'],
                    phone:'647-313-5766',
                    image:'https://media1.imgyb.xyz/media/v1/image/0c39c90679e8a310aae0d60f4382a5b7.jpeg/webp750',
                    url:'https://info.yorkbbs.ca/detail/tv/7cf2c5c2-0546-4daf-9edb-a67e4325ee07'
                },
                {
                    title:'Virgin Plus 手机，家庭网络返校优惠 $45 20GB',
                    tags:['手机计划','签约手机','家庭网络','手机'],
                    phone:'905-940-8886',
                    image:'https://media6.imgyb.xyz/media/v1/image/33ec6f2897be387141ab384c860c1e09.jpeg/webp750',
                    url:'https://forum.yorkbbs.ca/detail/3c6816ab-43e2-4e90-aef9-f08579bddfdd?topic=digital'
                },
                {
                    title:'通用数据分析师核心软件班',
                    tags:['数据分析','独家Coop项目','主流项目案例'],
                    phone:'416-665-1888',
                    image:'https://media3.imgyb.xyz/media/v1/image/64753b985c435f45f2ff845817ea699d.png/webp750',
                    url:'https://www.vicedu.com/classes/data_analyst/'
                },
            ]
        }
    }
}
</script>
<style lang="less" scoped>
/deep/.swiper-container{
    padding-bottom: 37px;
    .swiper-wrapper{
        .ig{margin-bottom: 5px; overflow: hidden; border-radius: 4px;
            a:hover{
                img{transform: scale(1.1); transition: all 200ms linear;}
            }
        }
        .title{font-size: 16px; line-height: 24px; font-weight: 400; margin-bottom: 10px;
            a{display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 2; /*截取4行*/ text-overflow: ellipsis; overflow: hidden;}
            a:hover{color: #e43a3a;}
        }
        .tag{display: flex; margin-bottom: 10px; flex-wrap: wrap; font-size: 14px; line-height: 20px; height: 20px; overflow: hidden;
            span{color: #999; margin-right: 10px;}
        }
        .phone{font-size: 16px; line-height: 22px; color: #E43A3A; font-weight: 600;}
    }
}

</style>